import { Routes } from "@angular/router";
import { BriTeammateLoginComponent } from "@davita/bridge-utility-library/login";
import { BriTeammateCanAccessGuard } from "@davita/bridge-utility-library/authorization";
import { LayoutComponent } from "./layout/layout.component";

export const routes: Routes = [
  { path: "", redirectTo: "overview/dashboard", pathMatch: "full" },
  {
    path: "teammate-login",
    component: BriTeammateLoginComponent,
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [BriTeammateCanAccessGuard],
    data: { loginPage: "/teammate-login" },
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./features/dashboard/dashboard.routes").then(
            (m) => m.DASHBOARD_ROUTES,
          ),
      },
      {
        path: "lab",
        loadChildren: () =>
          import("./features/lab/lab.routes").then((m) => m.LAB_ROUTES),
      },
      {
        path: "manage",
        loadChildren: () =>
          import("./features/manage/manage.routes").then((m) => m.MANAGE_ROUTES),
      },
      {
        path: "overview",
        loadChildren: () =>
          import("./features/overview/overview.routes").then(
            (m) => m.OVERVIEW_ROUTES,
          ),
      },
      {
        path: "build",
        loadChildren: () =>
          import("./features/build/build.routes").then((m) => m.BUILD_ROUTES),
      },
      {
        path: "simulate",
        loadChildren: () =>
          import("./features/simulate/simulate.routes").then(
            (m) => m.SIMULATE_ROUTES,
          ),
      },
      {
        path: "release",
        loadChildren: () =>
          import("./features/release/release.routes").then((m) => m.RELEASE_ROUTES),
      },
      {
        path: "evaluate",
        loadChildren: () =>
          import("./features/evaluate/evaluate.routes").then(
            (m) => m.EVALUATE_ROUTES,
          ),
      },
      {
        path: "observe",
        loadChildren: () =>
          import("./features/observe/observe.routes").then((m) => m.OBSERVE_ROUTES),
      },
      {
        path: "admin",
        loadChildren: () =>
          import("./features/admin/admin.routes").then((m) => m.ADMIN_ROUTES),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "overview/dashboard",
  },
];
